import { useOutletContext } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

import { ia } from 'lib/helpers/utility';

import Button from 'components/shared/Buttons/Button';

import EditResultButtons from './EditResultButtons';
import SendFaxButton from './SendFaxButton';
import SignButton from './SignButton';

const Head = ({
  itemPropsId,
  activeView,
  setActiveView,
  printRef,
  openResultsModal,
  actionViews,
  fromPatient
}) => {
  const { patient = {} } = useOutletContext() || {};

  const print = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `${activeView?.type}_for_${patient?.f_name}_${patient?.l_name}`
  });

  return activeView.component === 'preview' ? (
    <>
      <div className="flex justify-end">
        <div className="!mr-4 flex !gap-1">
          {activeView?.type === 'results' && activeView?.component === 'preview' ? (
            <EditResultButtons activeView={activeView} setActiveView={setActiveView} />
          ) : (
            <>
              <div className="!ml-3">
                <SignButton
                  actionViews={actionViews}
                  activeView={activeView}
                  itemPropsId={itemPropsId}
                />
              </div>
              {ia(activeView?.itemProps?.labOrderResults) && (
                <Button
                  type="secondary"
                  color="neutral"
                  icon="note-text-1-mono"
                  text="Results"
                  onClick={openResultsModal}
                  data-qa="results-btn"
                />
              )}
              <Button
                type="secondary"
                color="neutral"
                icon="printer-mono"
                text="Print"
                onClick={print}
                data-qa="print-btn"
              />
              {!fromPatient ? <SendFaxButton activeView={activeView} patient={patient} /> : null}
            </>
          )}
        </div>
      </div>
    </>
  ) : null;
};

export default Head;
